import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { loginWithEmail } from '../services/authService';
import Navbar from "../components/landingpage/sections/Navbar";

const LoginEmailOtp = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [credentials, setCredentials] = useState({
        userEmail: '',
        userPassword: ''
    });
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    // Pre-fill email if coming from registration
    useEffect(() => {
        if (location.state?.preFilledEmail) {
            setCredentials(prev => ({
                ...prev,
                userEmail: location.state.preFilledEmail
            }));
        }
    }, [location.state]);

    const handleChange = (e) => {
        setCredentials({
            ...credentials,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        try {
            const response = await loginWithEmail(credentials);
            console.log('LOGIN RESPONSE:', response);

            if (response.success) {
                navigate('/eotp', {
                    state: {
                        userEmail: credentials.userEmail,
                        userPassword: credentials.userPassword
                    }
                });
            }
        } catch (err) {
            setError(err.message || 'Failed to send OTP. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Navbar {...props} />
            {/* Page Content */}
            <div className="login-content-info">
                <div className="container">
                    {/* Login Email */}
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-md-6">
                            <div className="account-content">
                                <div className="account-info">
                                    <div className="login-title">
                                        <h3>Sign in</h3>
                                        <p>We'll send a confirmation code to your email.</p>
                                        {location.state?.preFilledEmail && (
                                            <div className="alert alert-info mt-3">
                                                <small>Registration successful! Please enter your password to receive OTP.</small>
                                            </div>
                                        )}
                                    </div>

                                    {error && (
                                        <div className="alert alert-danger mb-4">
                                            <div className="d-flex align-items-center">
                                                <i className="fas fa-exclamation-triangle me-2"></i>
                                                <div>
                                                    <strong>Error!</strong>
                                                    <div className="small">{error}</div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label className="form-label">Email Address</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                name="userEmail"
                                                value={credentials.userEmail}
                                                onChange={handleChange}
                                                placeholder="your@email.com"
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <label className="form-label">Password</label>
                                                <Link to="/forgot-password" className="forgot-link">
                                                    Forgot password?
                                                </Link>
                                            </div>
                                            <div className="pass-group" style={{ position: 'relative' }}>
                                                <input
                                                    type={isPasswordVisible ? "text" : "password"}
                                                    className="form-control pass-input-sub"
                                                    name="userPassword"
                                                    value={credentials.userPassword}
                                                    onChange={handleChange}
                                                    required
                                                />
                                                <span
                                                    onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                                                    style={{
                                                        position: 'absolute',
                                                        right: '10px',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                        cursor: 'pointer',
                                                        color: '#6c757d',
                                                        fontSize: '16px',
                                                        zIndex: 10
                                                    }}
                                                >
                                                    {isPasswordVisible ? '🙈' : '👁️'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="mb-3 form-check-box">
                                            <div className="form-group-flex">
                                                <div className="form-check mb-0">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="remember"
                                                        defaultChecked=""
                                                    />
                                                    <label className="form-check-label" htmlFor="remember">
                                                        Remember Me
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <button
                                                type="submit"
                                                className="btn btn-primary-gradient w-100"
                                                disabled={isLoading}
                                            >
                                                {isLoading ? 'Sending OTP...' : 'Send OTP'}
                                            </button>
                                        </div>
                                        <div className="login-or">
                                            <span className="or-line" />
                                            <span className="span-or">or</span>
                                        </div>
                                        <div className="account-signup">
                                            <p>
                                                Don't have an account? <Link to="/register">Sign up</Link>
                                            </p>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* /Login Email */}
                </div>
            </div>
            {/* /Page Content */}
        </>
    );
};

export default LoginEmailOtp;